import React from 'react';

import Embed from '../common/Embed.jsx';

function MapComponent(props) {
    let location;
    let url = `https://maps.google.com/maps?hl=en&t=m&output=embed`;
    let zoom = 12;
    if (props.blockConfig && props.blockConfig.block) {
        if (props.blockConfig.block.location) {
            location = props.blockConfig.block.location;
        }
        if (props.blockConfig.block.zoom) {
            zoom = props.blockConfig.block.zoom;
        }
    }
    if (!location && props.config) {
        const components = [];
        if (props.config.addressLineOne) {
            components.push(props.config.addressLineOne);
        }
        if (props.config.addressLineTwo) {
            components.push(props.config.addressLineTwo);
        }
        if (props.config.city) {
            components.push(props.config.city);
        }
        if (props.config.state) {
            components.push(props.config.state);
        }
        if (props.config.zip) {
            components.push(props.config.zip);
        }
        if (props.config.country) {
            components.push(props.config.country);
        }
        location = components.join('+')
    }
    if (!location) {
        location = 'Atlanta,+GA';
    }
    url = `${url}&q=${location}&z=${zoom}`;
    return <Embed.Component {...props} className="map__cont" embedType="map" url={url} />
}

export default { Component: MapComponent };